import { render, staticRenderFns } from "./ScanBoxQRCode.vue?vue&type=template&id=8271bdc4&scoped=true&"
import script from "./ScanBoxQRCode.vue?vue&type=script&lang=js&"
export * from "./ScanBoxQRCode.vue?vue&type=script&lang=js&"
import style0 from "./ScanBoxQRCode.vue?vue&type=style&index=0&id=8271bdc4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271bdc4",
  null
  
)

export default component.exports